import * as React from "react";
const SvgBookmark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 48v439.7a24.33 24.33 0 0 0 38.3 19.9L192 400l153.7 107.6a24.33 24.33 0 0 0 38.3-19.9V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48" }));
export default SvgBookmark;
